import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AttachFile = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.3306 2.54163C11.7039 1.91421 10.6879 1.91421 10.0612 2.54163L3.25312 9.35786C2.20867 10.4036 2.20867 12.099 3.25312 13.1447C4.29757 14.1904 5.99096 14.1904 7.03541 13.1447L13.8435 6.32843L14.6 7.08579L7.79187 13.902C6.32964 15.366 3.9589 15.366 2.49667 13.902C1.03444 12.438 1.03444 10.0645 2.49667 8.60051L9.30479 1.78427C10.3492 0.738576 12.0426 0.738576 13.0871 1.78427C14.1315 2.82997 14.1315 4.52537 13.0871 5.57107L6.27896 12.3873C5.65229 13.0147 4.63625 13.0147 4.00958 12.3873C3.38291 11.7599 3.38291 10.7426 4.00958 10.1152L10.8177 3.29899L11.5742 4.05635L4.76604 10.8726C4.55715 11.0817 4.55715 11.4208 4.76604 11.6299C4.97493 11.8391 5.31361 11.8391 5.5225 11.6299L12.3306 4.81371C12.9573 4.18629 12.9573 3.16905 12.3306 2.54163Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default AttachFile
